export const Colors = {
    botticelli: '#c2cfe080',
    black: '#192A3E',
    blackTitle: '#1c1b1f',
    gray: '#90A0B7',
    greyishBrown: '#4f4f4f',
    grayLight: '#E5E5E5',
    grayIcon: '#C2CFE0',
    grayFont: '#8f8f8f',
    grayBg: '#f2f2f2',
    grayBg2: '#FCFCFC',
    grayBorder: '#efefef',
    grayBorder2: '#e2e2e2',
    grayBorder3: '#dedede',
    grayBackground: '#f8f8f8',
    grayDisabled: '#b4b4b4',
    disabled: '#b8b8b8',
    darkBlue: '#334D6E',
    blueLink: '#109CF1',
    alert: '#eb5757',
    label: '#000',
    label2: 'rgba(0, 0, 0, 0.87)',
    label3: '#8F8F8F',
    successLabel: '#44b889',
    featuredText: '#828282',
    summaryBarText: '#7d7d7d',
    secondaryButton: '#bfbfbf',
    secondaryButtonText: '#828282',
    sectionToggleLabel: '#333333',
    white: '#fff',
    bianca: '#FDFCF5',
    eucalyptus: '#219653',
    gallery: '#eeeeee',
    yellowOrange: '#ffb74a',
    mobster: '#79747e',
    mauve: '#ce97ff',
    eletricViolet: '#7300d8',
    flushOrange: '#ff7a00',
    dustyGray: '#979797',
    royalBlue: '#2f80ed',
    mineShaft: '#333333',
    radicalRed: '#ff435a',
    denim: '#1967d2',
    whitesmoke: '#f5f5f5',
    lightGray1: '#DCDCDC',
    lightGray2: '#FFF',
    lightGray3: '#EEE',
    persianRed: '#d32f2f',
    alto: '#e0e0e0',
    lightBlue: '#eff8ff'
};

export const Fonts = {
    fontDefault: `'AkkuratLLTT', sans-serif`
};
